<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/organisation/bailleurs')"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Types de détails des étapes
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.push('/organisation/bailleurs')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text>
      <v-list>
        <v-list-item
          v-for="(item, index) in TypeDetailEtape"
          :key="index"
          class="project"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.label"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions({
      GetTypeDetailEtape: "TypeDetailEtape/GetAll",
    }),
  },
  created() {
    this.GetTypeDetailEtape();
  },
  computed: {
    ...mapState({
      TypeDetailEtape: (state) => state.TypeDetailEtape.TypeDetailEtape,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
